<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';
import { useStoreGetters, useMapGetter } from 'dashboard/composables/store';

import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import CampaignLayout from 'dashboard/components-next/Campaigns/CampaignLayout.vue';
import CampaignList from 'dashboard/components-next/Campaigns/Pages/CampaignPage/CampaignList.vue';
import ConfirmDeleteCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/ConfirmDeleteCampaignDialog.vue';
import PageEmptyState from 'escaleshop/shared/components/PageEmptyState.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const router = useRouter();
const { accountScopedRoute } = useAccount();
const getters = useStoreGetters();

const selectedCampaign = ref(null);
const confirmDeleteCampaignDialogRef = ref(null);

const uiFlags = useMapGetter('campaigns/getUIFlags');
const isFetchingCampaigns = computed(() => uiFlags.value.isFetching);

const WhatsAppCampaigns = computed(
  () => getters['campaigns/getWhatsAppCampaigns'].value
);

const hasNoWhatsAppCampaigns = computed(
  () => WhatsAppCampaigns.value?.length === 0 && !isFetchingCampaigns.value
);

const handleDelete = campaign => {
  selectedCampaign.value = campaign;
  confirmDeleteCampaignDialogRef.value.dialogRef.open();
};

const handleNewCampaign = () => {
  router.push(accountScopedRoute('campaigns_whatsapp_new'));
};

const handleViewDeliveries = campaign => {
  router.push(
    accountScopedRoute('campaigns_deliveries', { campaignId: campaign.id })
  );
};
</script>

<template>
  <CampaignLayout
    :header-title="t('CAMPAIGN.WHATSAPP.HEADER_TITLE')"
    :button-label="t('CAMPAIGN.WHATSAPP.NEW_CAMPAIGN')"
    @click="handleNewCampaign"
  >
    <div
      v-if="isFetchingCampaigns"
      class="flex items-center justify-center py-10 text-n-slate-11"
    >
      <Spinner />
    </div>
    <CampaignList
      v-else-if="!hasNoWhatsAppCampaigns"
      :campaigns="WhatsAppCampaigns"
      @delete="handleDelete"
      @view-deliveries="handleViewDeliveries"
    />
    <PageEmptyState
      v-else
      icon="i-lucide-message-circle"
      :title="t('CAMPAIGN.WHATSAPP.EMPTY_STATE.TITLE')"
      :description="t('CAMPAIGN.WHATSAPP.EMPTY_STATE.SUBTITLE')"
    >
      <Button
        icon="i-lucide-plus"
        size="sm"
        :label="t('CAMPAIGN.WHATSAPP.NEW_CAMPAIGN')"
        @click="handleNewCampaign"
      />
    </PageEmptyState>
    <ConfirmDeleteCampaignDialog
      ref="confirmDeleteCampaignDialogRef"
      :selected-campaign="selectedCampaign"
    />
  </CampaignLayout>
</template>
